/* QueryStatusConstant.js */

"use strict";

const QUERY_STATUSES = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown"
    },
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error"
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading"
    },
    COMPLETE: {
        name: "COMPLETE",
        title: "Complete",
        icon: "common.success"
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending"
    },
    CANCELED: {
        name: "CANCELED",
        title: "Canceled",
        icon: "common.skipped"
    }
};

module.exports = {
    QUERY_STATUSES
};
